import { lazy } from "react";

export const routes360 = [
  // Dashboard
  {
    path: "/360/dashboard",
    element: lazy(() => import("@/pages/360/DashboardPage")),
    meta: {
      title: "360 Dashboard",
      description: "Overview and analytics for 360 module"
    }
  },
  // My Activity
  {
    path: "/360/my-activity",
    element: lazy(() => import("@/pages/360/MyActivityPage")),
    meta: {
      title: "My Activity",
      description: "View your activity, proposals, events, and notifications"
    }
  },
  // Control Center (owners only: units with customer_id)
  {
    path: "/360/control-center",
    element: lazy(() => import("@/pages/360/ControlCenterPage")),
    meta: {
      title: "Control Center",
      description: "Control center for owners and their units"
    }
  },
  // CRM - Customers (Priority)
  {
    path: "/360/customers",
    element: lazy(() => import("@/pages/360/CustomersPage")),
    meta: {
      title: "Customers",
      description: "Manage customer relationships and profiles"
    }
  },
  {
    path: "/360/customers/new",
    element: lazy(() => import("@/pages/360/CustomerNewPage")),
    meta: {
      title: "New Customer",
      description: "Create a new customer"
    }
  },
  {
    path: "/360/customers/:id",
    element: lazy(() => import("@/pages/360/CustomerDetailPage")),
    meta: {
      title: "Customer Details",
      description: "View and edit customer information"
    }
  },
  {
    path: "/360/customers/:id/relationships",
    element: lazy(() => import("@/pages/360/CustomerRelationshipsPage")),
    meta: {
      title: "Customer Relationships",
      description: "Manage customer connections and relationships"
    }
  },
  {
    path: "/360/customers/:id/operations",
    element: lazy(() => import("@/pages/360/CustomerOperationsPage")),
    meta: {
      title: "Customer Operations",
      description: "Track customer transactions and operations"
    }
  },

  // Units
  {
    path: "/360/units",
    element: lazy(() => import("@/pages/360/UnitsPage")),
    meta: {
      title: "Units",
      description: "Manage property units and listings"
    }
  },
  {
    path: "/360/units/new",
    element: lazy(() => import("@/pages/360/UnitFormPage")),
    meta: {
      title: "New Unit",
      description: "Create a new unit"
    }
  },
  {
    path: "/360/units/:id",
    element: lazy(() => import("@/pages/360/UnitDetailPage")),
    meta: {
      title: "Unit Details",
      description: "View and edit unit information"
    }
  },
  {
    path: "/360/units/:id/edit",
    element: lazy(() => import("@/pages/360/UnitDetailPage")),
    meta: {
      title: "Edit Unit",
      description: "Edit unit information"
    }
  },

  // Projects
  {
    path: "/360/projects",
    element: lazy(() => import("@/pages/360/ProjectsPage")),
    meta: {
      title: "Projects",
      description: "Manage real estate projects"
    }
  },
  {
    path: "/360/projects/:id",
    element: lazy(() => import("@/pages/360/ProjectDetailPage")),
    meta: {
      title: "Project Details",
      description: "View and edit project information"
    }
  },
  {
    path: "/360/projects/:id/edit",
    element: lazy(() => import("@/pages/360/ProjectEditPage")),
    meta: {
      title: "Edit Project",
      description: "Edit project information"
    }
  },

  // Proposals
  {
    path: "/360/proposals",
    element: lazy(() => import("@/pages/360/ProposalsPage")),
    meta: {
      title: "Proposals",
      description: "Manage property proposals"
    }
  },
  {
    path: "/360/proposals/:id",
    element: lazy(() => import("@/pages/360/ProposalDetailPage")),
    meta: {
      title: "Proposal Details",
      description: "View and edit proposal information"
    }
  },
  {
    path: "/360/proposals/:id/edit",
    element: lazy(() => import("@/pages/360/ProposalDetailPage")),
    meta: {
      title: "Edit Proposal",
      description: "Edit proposal information"
    }
  },
  {
    path: "/360/proposals/:id/build",
    element: lazy(() => import("@/pages/360/ProposalBuilderPage")),
    meta: {
      title: "Build Proposal",
      description: "Create or edit a proposal"
    }
  },
  {
    path: "/360/proposals/:id/view",
    element: lazy(() => import("@/pages/360/ProposalViewPage")),
    meta: {
      title: "View Proposal",
      description: "Public proposal view"
    }
  },

  // Events & Campaigns
  {
    path: "/360/events",
    element: lazy(() => import("@/pages/360/EventsPage")),
    meta: {
      title: "Events",
      description: "Manage lead events and activities"
    }
  },
  {
    path: "/360/external-chatbot",
    element: lazy(() => import("@/pages/360/ExternalChatbotPage")),
    meta: {
      title: "External Chatbot",
      description: "Manage external chatbot inquiries"
    }
  },
  {
    path: "/360/events/thread-view",
    element: lazy(() => import("@/pages/360/EventsThreadViewPage")),
    meta: {
      title: "Events Thread View",
      description: "View events in a timeline thread format"
    }
  },
  {
    path: "/360/events/new",
    element: lazy(() => import("@/pages/360/EventFormPage")),
    meta: {
      title: "Create Event",
      description: "Create a new event"
    }
  },
  {
    path: "/360/events/:id",
    element: lazy(() => import("@/pages/360/EventViewPage")),
    meta: {
      title: "View Event",
      description: "View event details"
    }
  },
  {
    path: "/360/events/:id/edit",
    element: lazy(() => import("@/pages/360/EventFormPage")),
    meta: {
      title: "Edit Event",
      description: "Edit event information"
    }
  },
  {
    path: "/360/users",
    element: lazy(() => import("@/pages/360/UsersPage")),
    meta: {
      title: "Users",
      description: "Manage system users"
    }
  },
  {
    path: "/360/users/:id",
    element: lazy(() => import("@/pages/360/UserDetailPage")),
    meta: {
      title: "User Details",
      description: "View user activity and details"
    }
  },
  {
    path: "/360/campaigns",
    element: lazy(() => import("@/pages/360/CampaignsPage")),
    meta: {
      title: "Campaigns",
      description: "Manage marketing campaigns"
    }
  },
  {
    path: "/360/campaigns/new",
    element: lazy(() => import("@/pages/360/CampaignFormPage")),
    meta: {
      title: "Create Campaign",
      description: "Create a new campaign"
    }
  },
  {
    path: "/360/campaigns/:id/edit",
    element: lazy(() => import("@/pages/360/CampaignFormPage")),
    meta: {
      title: "Edit Campaign",
      description: "Edit campaign information"
    }
  },
  {
    path: "/360/campaigns/:id",
    element: lazy(() => import("@/pages/360/CampaignDetailPage")),
    meta: {
      title: "Campaign Details",
      description: "View and edit campaign information"
    }
  },
  {
    path: "/360/campaigns/:id/customers",
    element: lazy(() => import("@/pages/360/CampaignCustomerPage")),
    meta: {
      title: "Campaign Customers",
      description: "Track campaign customer engagement"
    }
  },

  // Visits
  {
    path: "/360/visits",
    element: lazy(() => import("@/pages/360/VisitsPage")),
    meta: {
      title: "Visits",
      description: "Schedule and manage property visits"
    }
  },
  // Log
  {
    path: "/360/log",
    element: lazy(() => import("@/pages/360/LogPage")),
    meta: {
      title: "Log",
      description: "View system activity and event logs"
    }
  },
  {
    path: "/360/visits/:id",
    element: lazy(() => import("@/pages/360/VisitDetailPage")),
    meta: {
      title: "Visit Details",
      description: "View and edit visit information"
    }
  },
  {
    path: "/360/visits/:id/report",
    element: lazy(() => import("@/pages/360/VisitReportsPage")),
    meta: {
      title: "Visit Report",
      description: "Visit feedback and ratings"
    }
  },

  // Operations
  {
    path: "/360/operations",
    element: lazy(() => import("@/pages/360/OperationsPage")),
    meta: {
      title: "Operations",
      description: "Track business operations"
    }
  },

  // Settings & Configuration
  {
    path: "/360/settings",
    element: lazy(() => import("@/pages/360/SettingsPage")),
    meta: {
      title: "360 Settings",
      description: "Configure 360 module settings"
    }
  },
  {
    path: "/360/settings/statuses",
    element: lazy(() => import("@/pages/360/StatusSettingsPage")),
    meta: {
      title: "Status Management",
      description: "Manage unit statuses, campaign statuses, and seller statuses"
    }
  },
  {
    path: "/360/settings/types",
    element: lazy(() => import("@/pages/360/TypeSettingsPage")),
    meta: {
      title: "Type Management",
      description: "Manage unit types, project types, and other classifications"
    }
  },
  {
    path: "/360/settings/currencies",
    element: lazy(() => import("@/pages/360/CurrencySettingsPage")),
    meta: {
      title: "Currency Management",
      description: "Manage currencies and exchange rates"
    }
  },
  {
    path: "/360/settings/offices",
    element: lazy(() => import("@/pages/360/OfficeSettingsPage")),
    meta: {
      title: "Office Management",
      description: "Manage office locations and information"
    }
  },
  {
    path: "/360/settings/reasons",
    element: lazy(() => import("@/pages/360/ReasonSettingsPage")),
    meta: {
      title: "Reason Management",
      description: "Manage purchase, sale, and seller reasons"
    }
  },

  // Funnels
  {
    path: "/360/funnel/buyers",
    element: lazy(() => import("@/pages/360/BuyerFunnelPage")),
    meta: {
      title: "Buyer Funnel",
      description: "Manage buyer funnel stages"
    }
  },
  {
    path: "/360/funnel/owners",
    element: lazy(() => import("@/pages/360/OwnerFunnelPage")),
    meta: {
      title: "Owner Funnel",
      description: "Manage owner funnel stages"
    }
  },
  {
    path: "/360/funnel/loyalty",
    element: lazy(() => import("@/pages/360/LoyaltyFunnelPage")),
    meta: {
      title: "Loyalty Funnel",
      description: "Manage loyalty funnel stages"
    }
  }
];

